import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  // Autocomplete,
  // InputAdornment,
  IconButton,
  FormGroup,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { FaFileSignature, FaHandsHelping } from "react-icons/fa";
// import { onlyNumber } from "../utils/inputsRules";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import { formatAuthorityCrimes } from "../utils/formatAuthorityCrimes";
import ModalText from "../components/ModalText";
import "dayjs/locale/es";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import SearchIcon from "@mui/icons-material/Search";
// import { RiFileExcel2Line } from "react-icons/ri";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import { GrDocumentDownload } from "react-icons/gr";



const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTable: {
        styleOverrides: {
          root: {
            borderRadius: "30px !important",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#3c6218 !important",

            color: "white",
          },
        },
      },
    },
  });

const VictimasView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",

    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      sm: "80%",
      md: 1200,
    },
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: {
      xs: "90vh",
      sm: "80vh",
      md: "90%",
    },
    borderRadius: "40px",
  };
  
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",

    "&:hover": {
      backgroundColor: "#661d40",

    },
    borderRadius: "40px",
  }));

  const [loader, setLoader] = useState({
    loading: true,
  });

  const { showNotification } = useContext(NotificacionContext);

  const [state, setState] = useState({
    victimas: [],
    municipios: [],
    localidades: [],
    openDocumento: false,
    victimaSeleccionado: {},
    openDescripcion: false,
    descripcion: "",

    requests: [],
  });

  const openModalDescripcion = (descripcion) => {
    setState((prev) => ({
      ...prev,
      openDescripcion: true,
      descripcion,
    }));
  };

  const handleCloseDescripcion = () => {
    setState((prev) => ({ ...prev, openDescripcion: false }));
  };

  const [formularioState, setFormulario] = useState({
      collective: "",
      observations: "",
  });
  
  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;
  const goTo = useNavigate();

  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";

  const isPrimerContacto =normalizeValue(localStorage.getItem("area_type")) === "PRIMERCONTACTO";

  const [openModal, setopenModal] = useState(false);
  // const [openModalEditarState, setopenModalEditar] = useState(false);
  const [openModalEliminar, setopenModalEliminar] = useState(false);

  const openModalAñadir = async (data) => {
     setLoader({ ...loader, loading: true });
       setState({
         ...state,
         victimaSeleccionado: data,
       });
       setLoader({ ...loader, loading: false });
       setopenModal(true);
  };
    
  const openmodaleliminar = (data) => {
    setState({ ...state, victimaSeleccionado: data });
    setopenModalEliminar(true);
  };

  const validarFormulario = () => {
    let newErrors = {};
    // if (!formularioState.victim_id) {
    //   newErrors.citizen = "Este Campo es requerido";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const limpiarFormulario = () => {
    setFormulario({
      ...formularioState,
      collective: "",
      observations: "",
    });
  };

  const createRequest = async () => {
      if (validarFormulario()) {
        setLoader({ ...loader, loading: true });
        const body = {
          collective: formularioState.collective,
          observations: formularioState.observations?.toUpperCase(),
          victim_id: state.victimaSeleccionado.id
        };
        const request = await services({
          method: "POST",
          service: "applications",
          body,
        });
        if (request.status === 201) {
          limpiarFormulario();
          setopenModal(false);
          setLoader({ ...loader, loading: false });

          if (request?.data?.data?.id) {
            goTo(`/solicitudesVictimas/solicitud/${request.data.data.id}`);
          }

          showNotification(
            "success",
            "Solicitud Creada con Éxito",
            "Tu folio es:" + request.data.data.folio,
            null,
          );
  
        } else {
          setState({
            ...state,
            collective: "",
            observations: "",
          });
          setopenModal(false);
          limpiarFormulario();
          setLoader({ ...loader, loading: false });
          showNotification(
            "error",
            "Crear Solicitud",
            request.data.message,
            null,
            4,
          );
        }
      } else {
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups...",
          "Favor de llenar los campos",
          null,
          4,
        );
      }
    };

  const handleObservations = (e) => {
    setFormulario({ ...formularioState, observations: uppercaseText(e.target.value)});
  };

  const handleCollective = (e) => {
    setFormulario({ ...formularioState, collective: e.target.value });
  };

  const handleCloseDocumento = () => {
    // setState({ ...state, openDocumento: false });
  

    if (state.urlFrame) {
        URL.revokeObjectURL(state.urlFrame);
    }

    setState({
        ...state,
        openDocumento: false,
        urlFrame: ""
    });
  };

  const handleCloseEliminar = () => {

    setopenModalEliminar(false);
  };

  const [errors, setErrors] = useState({});

  const uppercaseFilterDisplay = (filterList, onChange, index, column) => (
    <TextField
      fullWidth
      size="small"
      label={column.label}
      value={filterList[index]?.[0] || ""}
      onChange={(event) =>
        onChange([event.target.value.toUpperCase()], index, column)
      }
    />
  );

  const columns = [
    {
      name: "name",
      label: "VÍCTIMA",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          // let nombre = state.victimas[dataIndex].name;
          let nombre = `${state.victimas[dataIndex].name} ${state.victimas[dataIndex].first_lastname} ${state.victimas[dataIndex].second_lastname ? state.victimas[dataIndex].second_lastname : ""}`;
          let nombre_completo = state.victimas[dataIndex].name;

          return (
            <>
              <div
                className="d-flex align-items-center"
                style={{ height: "60px" }}
              >
                {nombre}
              </div>
              <div className="d-none">{nombre_completo}</div>
            </>
          );
        },
      },
    },
    {
      name: "ceeav_code",
      label: "COD-CEEAV",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let ceeav_code = state.victimas[dataIndex]?.complementary_form?.ceeav_code;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {ceeav_code}
            </div>
          );
        },
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        filterType: "dropdown",
        filterOptions: {
          names: ["DIRECTA", "INDIRECTA", "POTENCIAL"],
        },
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let tipo_victima = state.victimas[dataIndex].victim_type;
          return (
            <div
              className=" d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {tipo_victima}
            </div>
          );
        },
      },
    },
    {
      name: "crime",
      label: "DELITO / VIOL. D.H.",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const authority = state.victimas[dataIndex]?.authority;
          const crimeDescription = formatAuthorityCrimes(authority);
          const isLongDescription = crimeDescription.length > 50;

          return (
            <div
              className={`d-flex align-items-center${isLongDescription ? " cursor-pointer" : ""}`}
              style={{ height: "60px" }}
              onClick={
                isLongDescription
                  ? () => openModalDescripcion(crimeDescription)
                  : undefined
              }
            >
              {isLongDescription
                ? `${crimeDescription.substring(0, 50)} ...`
                : crimeDescription}
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "CONTACTO",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let contacto = state.victimas[dataIndex].phone;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {contacto}
            </div>
          );
        },
      },
    },
    {
      name: "municipio",
      label: "MUNICIPIO",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipio = state.victimas[dataIndex].municipality?.name;
          if (municipio !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {municipio}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "localidad",
      label: "LOCALIDAD",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let localidad = state.victimas[dataIndex].locality?.name;
          if (localidad !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {localidad}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "nuc",
      label: "NUC",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let nuc = state.victimas[dataIndex].authority.mp_nuc;
          if (nuc !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {nuc}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "ap_ci",
      label: "A.P./C.I.",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let ap_ci = state.victimas[dataIndex].authority.mp_file_type;
          if (ap_ci !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {ap_ci}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "exp",
      label: "NO. EXPEDIENTE",
      options: {
        filter: true,
        filterType: "custom",
        filterOptions: { display: uppercaseFilterDisplay },
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let exp = state.victimas[dataIndex].authority.mp_exp;
          if (exp !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {exp}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center justify-content-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
        name: "date",
        label: "FECHA",
        options: {
          filter: true,
          sort: false,
          download: false,
          customBodyRenderLite: (dataIndex) => {
            const fecha = state.victimas[dataIndex].date;
            const alta = dayjs(fecha);
            return (
              <div
                className="d-flex align-items-center"
                style={{ height: "60px" }}
              >
                {alta.isValid() ? alta.format("DD-MM-YYYY") : "-"}
              </div>
            );
          },
          filterType: "custom",
          customFilterListOptions: {
            render: (v) => {
              const startDate = v[0] ? dayjs(v[0]) : null;
              const endDate = v[1] ? dayjs(v[1]) : null;

              if (startDate?.isValid() && endDate?.isValid() && state.FilterChecked) {
                return [
                  `FECHA INICIO: ${startDate.format("DD-MM-YYYY")}`,
                  `FECHA FINAL: ${endDate.format("DD-MM-YYYY")}`,
                ];
              } else if (startDate?.isValid() && endDate?.isValid() && !state.FilterChecked) {
                return `FECHA INICIO: ${startDate.format("DD-MM-YYYY")}, FECHA FINAL: ${endDate.format("DD-MM-YYYY")}`;
              } else if (startDate?.isValid()) {
                return `FECHA INICIO: ${startDate.format("DD-MM-YYYY")}`;
              } else if (endDate?.isValid()) {
                return `FECHA FINAL: ${endDate.format("DD-MM-YYYY")}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, "");
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }

              return filterList;
            },
          },
          filterOptions: {
            names: [],
            logic: (createdAt, filters) => {
              const createdDate = dayjs(createdAt);
              if (!createdDate.isValid()) return true;

              const date = createdDate.format("YYYY-MM-DD");
              const startDate = filters[0] ? dayjs(filters[0]) : null;
              const endDate = filters[1] ? dayjs(filters[1]) : null;

              return Boolean(
                (startDate?.isValid() && date < startDate.format("YYYY-MM-DD")) ||
                (endDate?.isValid() && date > endDate.format("YYYY-MM-DD"))
              );
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <FormLabel className="mb-2" style={{ fontSize: "12px" }}>
                  RANGO DE FECHAS
                </FormLabel>
                <FormGroup row>
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="INICIO"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index]?.[0]
                          ? dayjs(filterList[index][0])
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        const updatedFilter = [...(filterList[index] || ["", ""])];
                        updatedFilter[0] = event?.isValid()
                          ? event.format("YYYY-MM-DD")
                          : "";
                        onChange(updatedFilter, index, column);
                      }}
                      style={{ width: "40%" }}
                    />
                  </LocalizationProvider>
   
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <DatePicker
                      label="FINAL"
                      slotProps={{ textField: { size: "small" } }}
                      value={
                        filterList[index]?.[1]
                          ? dayjs(filterList[index][1])
                          : null
                      }
                      views={["day", "month", "year"]}
                      onChange={(event) => {
                        const updatedFilter = [...(filterList[index] || ["", ""])];
                        updatedFilter[1] = event?.isValid()
                          ? event.format("YYYY-MM-DD")
                          : "";
                        onChange(updatedFilter, index, column);
                      }}
                      style={{ width: "40%", marginLeft: "10px" }}
                    />
                  </LocalizationProvider>
                </FormGroup>
              </div>
            ),
          },
        },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              <Tooltip title="CREAR SOLICITUD">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openModalAñadir(state.victimas[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <FaHandsHelping />
                  </IconUI>
                </div>
              </Tooltip>
              <Tooltip title="VER SOLICITUDES ">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    goTo(
                      `/solicitudesVictimas/${state.victimas[dataIndex].id}`,
                    );
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <FaFileSignature />
                  </IconUI>
                </div>
              </Tooltip>

              <Tooltip title="VER FUD">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    descargarDocumentos(state.victimas[dataIndex].id);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <GrDocumentDownload />
                  </IconUI>
                </div>
              </Tooltip>
              <Tooltip title="EDITAR FUD">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    goTo(`/crear-fud/${state.victimas[dataIndex].id}`);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineEdit />
                  </IconUI>
                </div>
              </Tooltip>
              {(!isPrimerContacto) && (
                <Tooltip title="ELIMINAR VICTIMA">
                  <div
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn"
                    onClick={() => {
                      openmodaleliminar(state.victimas[dataIndex]);
                    }}
                  >
                    <IconUI size={"20px"} color={"black"}>
                      <AiOutlineDelete />
                    </IconUI>
                  </div>
                </Tooltip>
              )}
            </div>
          </>
        ),
      },
    },
  ];

  const [totalCiudadanos, setTotalCiudadanos] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const normalizePaginatedResponse = (payload) => {
    const source = payload?.data ?? payload ?? {};
    const rows = Array.isArray(source?.data)
      ? source.data
      : Array.isArray(source)
        ? source
        : [];
    const total = Number(source?.total ?? payload?.total ?? rows.length ?? 0);

    return { rows, total };
  };

  const getServerFilters = (filterList = []) => {
  const filters = {};

  const getValue = (index) => {
    const value = filterList[index]?.[0];
      return typeof value === "string" ? value.trim() : value;
    };

    if (getValue(0)) filters.name = getValue(0);
    if (getValue(1)) filters.ceeav_code = getValue(1);
    if (getValue(2)) filters.victim_type = getValue(2);
    if (getValue(3)) filters.crime = getValue(3);
    if (getValue(4)) filters.phone = getValue(4);
    if (getValue(5)) filters.municipality = getValue(5);
    if (getValue(6)) filters.locality = getValue(6);
    if (getValue(7)) filters.nuc = getValue(7);
    if (getValue(8)) filters.ap_ci = getValue(8);
    if (getValue(9)) filters.exp = getValue(9);

    const dateFilter = filterList[10] || [];

    const startDate = dateFilter[0] ? dayjs(dateFilter[0]) : null;
    const endDate = dateFilter[1] ? dayjs(dateFilter[1]) : null;

    if (startDate?.isValid()) {
      filters.date_start = startDate.format("YYYY-MM-DD");
    }

    if (endDate?.isValid()) {
      filters.date_end = endDate.format("YYYY-MM-DD");
    }
    return filters;
  };

  // const mostrarVictimas = async (pageIndex = 0, rowsPerPage = 10) => {
  //   if (buscar) {
  //     setBuscar(false);
  //     pageIndex = 0;
  //     setPage(0);
  //     setBuscador({ ...buscador, error: "" });
  //   }
  //   setLoader({ ...loader, loading: true });

  //   let victimas = await services({
  //     method: "GET",
  //     service: `fud/?page=${pageIndex + 1}`,
  //     body: null,
  //   });

  //   if (victimas.status === 200) {
  //     const { rows, total } = normalizePaginatedResponse(victimas.data);
  //     setState({ ...state, victimas: rows });
  //     setTotalCiudadanos(total);
  //     setLoader({ ...loader, loading: false });
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "ups... Algo sucedió",
  //       "La información no fue cargada correctamente",
  //       null,
  //       4,
  //     );
  //   }
  // };

  const mostrarVictimas = async ({
    pageIndex = 0,
    rowsPerPageValue = 10,
    search = "",
    filterList = [],
  } = {}) => {
    setLoader((prev) => ({ ...prev, loading: true }));

    const filters = getServerFilters(filterList);
    const params = new URLSearchParams();

    params.set("page", String(pageIndex + 1));
    params.set("per_page", String(rowsPerPageValue));

    if (search?.trim()) {
      params.set("search", search.trim());
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.set(key, value);
      }
    });

    try {
      const victimas = await services({
        method: "GET",
        service: `fud/?${params.toString()}`,
        body: null,
      });

      if (victimas.status === 200) {
        const { rows, total } = normalizePaginatedResponse(victimas.data);

        setState((prev) => ({
          ...prev,
          victimas: rows,
        }));

        setTotalCiudadanos(total);
      } else {
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "La información no fue cargada correctamente",
          null,
          4,
        );
      }
    } catch (error) {
      console.error("Error al cargar víctimas:", error);

      showNotification(
        "error",
        "Ups... Algo sucedió",
        "No fue posible cargar la información",
        null,
        4,
      );
    } finally {
      setLoader((prev) => ({ ...prev, loading: false }));
    }
  };

  const [buscar, setBuscar] = useState(false);
  const [buscador, setBuscador] = useState({
    texto: "",
    error: "",
  });

  // const handleChangeBuscador = (e) => {
  //   setBuscador({ ...buscador, texto: e.target.value });
  // };

  const validarBuscador = async (pageIndex = 0) => {
    if (!buscador.texto) {
      const pagOriginal = 0;
      mostrarVictimas(pagOriginal);
      setBuscador({ ...buscador, error: "El campo no puede ir vacío" });
      setTimeout(() => {
        setBuscador({ ...buscador, error: "" });
      }, 3000);
    } else {
      setLoader({ ...loader, loading: true });
      const body = {
        buscador: buscador.texto,
        cantidad: 10,
      };
      const request = await services({
        method: "POST",
        service: `ciudadanos/buscarCiudadano?page=${pageIndex + 1}`,
        body,
      });

      if (request.status === 200) {
        setBuscar(true);
        setBuscador({ ...buscador, error: "" });
        setState({ ...state, ciudadanos: request.data.data.data });
        setTotalCiudadanos(request.data.data.total);
        setLoader({ ...loader, loading: false });
      } else if (request.status === 500) {
        setLoader({ ...loader, loading: false });
        setBuscador({
          ...buscador,
          error: "Ha ocurrido un error en el servidor",
        });
      } else {
        setLoader({ ...loader, loading: false });
        setBuscador({ ...buscador, error: request.data.message });
      }
    }
  };

  // const exportar = async () => {
  //   setLoader({ ...loader, loading: true });

  //   let response = await services(
  //     {
  //       method: "POST",
  //       service: `ciudadanos/exportar`,
  //       body: { buscador: buscador.texto },
  //     },
  //     {
  //       responseType: "arraybuffer",
  //     },
  //   );
  //   if (response.status === 200) {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "success",
  //       "Éxito",
  //       "Se ha descargado su archivo",
  //       null,
  //       4,
  //     );
  //     const link = document.createElement("a");
  //     link.href = `data:application/octet-stream;base64,${response.data.archivo}`;
  //     link.download = "Ciudadanos.xlsx";
  //     link.click();
  //   } else {
  //     setLoader({ ...loader, loading: false });
  //     showNotification(
  //       "error",
  //       "Ups...",
  //       "Ocurrió algo al descargar su archivo",
  //       null,
  //       4,
  //     );
  //   }
  // };

  // const customOptions = {
  //   filter: false,
  //   search: false,
  //   download: false,
  //   print: false,
  //   viewColumns: false,
  //   serverSide: true,
  //   count: totalCiudadanos,
  //   page,
  //   rowsPerPage,
  //   onTableChange: async (action, tableState) => {
  //     if (action === "changePage") {
  //       setPage(tableState.page);
  //     }
  //     if (action === "changeRowsPerPage") {
  //       setRowsPerPage(tableState.rowsPerPage);
  //       setPage(0);
  //     }
  //   },
  //   rowsPerPageOptions: [],
  //   selectableRows: "none",
  //   textLabels: {
  //     body: {
  //       noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
  //       toolTip: "Clasificar",
  //       columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
  //     },
  //   },
  // };

  const customOptions = {
    filter: true,
    search: true,
    download: false,
    print: false,
    viewColumns: false,
    serverSide: true,
    count: totalCiudadanos,
    page,
    rowsPerPage,
    rowsPerPageOptions: [10, 25, 50],
    selectableRows: "none",

    onTableChange: async (action, tableState) => {
      const currentPage = tableState.page ?? 0;
      const currentRowsPerPage = tableState.rowsPerPage ?? rowsPerPage;
      const currentSearch = tableState.searchText || "";
      const currentFilterList = tableState.filterList || [];

      switch (action) {
        case "changePage":
          setPage(currentPage);
          await mostrarVictimas({
            pageIndex: currentPage,
            rowsPerPageValue: currentRowsPerPage,
            search: currentSearch,
            filterList: currentFilterList,
          });
          break;

        case "changeRowsPerPage":
          setRowsPerPage(currentRowsPerPage);
          setPage(0);
          await mostrarVictimas({
            pageIndex: 0,
            rowsPerPageValue: currentRowsPerPage,
            search: currentSearch,
            filterList: currentFilterList,
          });
          break;

        case "search":
        case "filterChange":
          setPage(0);
          await mostrarVictimas({
            pageIndex: 0,
            rowsPerPageValue: currentRowsPerPage,
            search: currentSearch,
            filterList: currentFilterList,
          });
          break;

        case "resetFilters":
          setPage(0);
          await mostrarVictimas({
            pageIndex: 0,
            rowsPerPageValue: currentRowsPerPage,
            search: currentSearch,
            filterList: [],
          });
          break;

        case "resetSearch":
          setPage(0);
          await mostrarVictimas({
            pageIndex: 0,
            rowsPerPageValue: currentRowsPerPage,
            search: "",
            filterList: currentFilterList,
          });
          break;

        default:
          break;
      }
    },

    textLabels: {
      body: {
        noMatch: "Lo sentimos, no hay coincidencias en la búsqueda",
        toolTip: "Clasificar",
        columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente página",
        previous: "Página anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        filterTable: "Filtros",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
    },
  };


  const descargarDocumentos = async (id) => {

    setLoader({ ...loader, loading: true });

    let response = await services({
        method: "GET",
        service: `fud/${id}/pdf`,
        responseType: "blob"
    });

    setLoader({ ...loader, loading: false });

    if (response.status === 200) {

        const pdfBlob = new Blob(
            [response.data],
            { type: "application/pdf" }
        );

        const pdfUrl = URL.createObjectURL(pdfBlob);

        setState({
            ...state,
            openDocumento: true,
            urlFrame: pdfUrl
        });

    } else {

        showNotification(
            "error",
            "Ups...Algo Sucedió",
            "No fue posible generar el documento",
            null,
            4
        );

    }
  }

  const eliminarVictima = async () => {
    setLoader({ ...loader, loading: true });
    const victima = await services({
      method: "DELETE",
      service: `fud/${state.victimaSeleccionado.id}`,
      body: null,
    });
    if (victima.status === 200) {

      setopenModalEliminar(false);
      mostrarVictimas(page);
      showNotification("success", "Victima", "Eliminada con Éxito", null, 4);
      setLoader({ ...loader, loading: false });
    } else {

      setopenModalEliminar(false);
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "ups... Algo sucedió",
        victima.data.message,
        null,
        4,
      );
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      if (!buscar) {
        mostrarVictimas(page);
      } else {
        validarBuscador(page);
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={6}>
              {/* <TextField
                sx={{
                  borderRadius: "30px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
                fullWidth
                size="small"
                id="busqueda"
                type="text"
                label="Buscar..."
                variant="outlined"
                value={buscador.texto}
                error={!!buscador.error}
                helperText={buscador.error || ""}
                onChange={handleChangeBuscador}
                InputProps={{
                  maxLength: 100,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setPage(0);
                          validarBuscador();
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>

            <Grid item>
              {/* <ColorButton
                startIcon={<RiFileExcel2Line />}
                className="me-3"
                onClick={exportar}
              >
                exportar
              </ColorButton> */}
              <ColorButton
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  goTo('/crear-fud');
                }}
              >
                NUEVO REGISTRO
              </ColorButton>
            </Grid>
          </Grid>
        </div>
        <Box sx={{ flexGrow: 2 }}>
          <Grid className="container mt-3 mb-3" maxWidth="xl">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                data={state.victimas}
                title={`TABLA DE VICTIMAS`}
                columns={columns}
                options={customOptions}
              />
            </ThemeProvider>
          </Grid>
        </Box>

        <ModalText
          open={state.openDescripcion}
          onClose={handleCloseDescripcion}
          descripcion={state.descripcion}
        />

        <Modal
          open={openModal}
          onClose={() => setopenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">CREAR SOLICITUD</h3>
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      borderRadius: "30px",
                      "& .MuiSelect-select": { paddingRight: "64px !important" },
                    }}
                    fullWidth
                    size="small"
                    id="collective"
                    label="COLECTIVO"
                    variant="outlined"
                    select
                    error={!!errors.collective}
                    helperText={errors.collective || ""}
                    value={formularioState.collective}
                    onChange={handleCollective}
                  >
                    <MenuItem value={"EN TU BÚSQUEDA MICHOACÁN"}>EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                    <MenuItem value={"BUSCANDO TUS PASOS"}>BUSCANDO TUS PASOS</MenuItem>
                    <MenuItem value={"DECOFEM"}>DECOFEM</MenuItem>
                    <MenuItem value={"CODEMICH"}>CODEMICH</MenuItem>
                    <MenuItem value={"SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN"}>SOMOS LA VOZ DE LOS DESAPARECIDOS MICHOACÁN</MenuItem>
                    <MenuItem value={"FAMILIARES EN TU BÚSQUEDA MICHOACÁN"}>FAMILIARES EN TU BÚSQUEDA MICHOACÁN</MenuItem>
                    <MenuItem value={"HUELLAS MICHOACÁN"}>HUELLAS MICHOACÁN</MenuItem>
                    <MenuItem value={"BUSCANDO CUERPOS EN TODO MÉXICO"}>BUSCANDO CUERPOS EN TODO MÉXICO</MenuItem>
                  </TextField>
                  {formularioState.collective && (
                    <IconButton
                      aria-label="Limpiar colectivo"
                      title="Limpiar colectivo"
                      size="small"
                      onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        setFormulario((prev) => ({ ...prev, collective: "" }));
                      }}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 32,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="OBSERVACIONES"
                  multiline
                  rows={3}
                  value={formularioState.observations}
                  error={!!errors.observations}
                  helperText={errors.observations || ""}
                  onChange={handleObservations}
                />
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton onClick={createRequest}>Crear</ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        
        <Modal
            open={state.openDocumento}
            onClose={() => handleCloseDocumento()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="contenedorModalUrs" sx={style3}>
              <p className="text-center">Documento</p>
              <iframe
                style={{ width: "100%", height: "100%" }}
                id="frameAceptacion"
                title="DOCUMENTO"
                src={state.urlFrame}
                className="preview-iframe"
              ></iframe>
              <Button sx={{ mt: 2 }} onClick={() => handleCloseDocumento()}>
                Cerrar
              </Button>
            </Box>
        </Modal>
        <Modal
          open={openModalEliminar}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas  mb-5">
              ¿ESTÁ SEGURO DE ELIMINAR A LA VÍCTIMA?
            </h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>
                  {state.victimaSeleccionado && state.victimaSeleccionado.name
                    ? `${state.victimaSeleccionado.name || ""} ${state.victimaSeleccionado.first_lastname || ""} ${state.victimaSeleccionado.second_lastname || ""}`
                    : "Información no disponible"}
                </h4>
              </Grid>

              <Grid margin="auto" item>
                <ColorButton
                  onClick={() => {
                    eliminarVictima();
                  }}
                >
                  ELIMINAR
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default VictimasView;
